import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/modal';

export const initialState = {
  isOpen: false,
};

const reducer = ( state = initialState, action ) => {
  if ( action.type === actions.types.ON_CLOSE_MODAL ) {
    return Object.assign(
      {},
      state,
      {
        isOpen: false,
      },
    );
  }
  else if ( action.type === actions.types.ON_OPEN_MODAL ) {
    return Object.assign(
      {},
      state,
      {
        isOpen: true,
      },
    );
  }

  return state;
};

const mapStateToProps = ( { modal } ) => ( {
    modal,
} );

const mapDispatchToProps = dispatch => (
    bindActionCreators( {
        onCloseModal: actions.onCloseModal,
        onOpenModal: actions.onOpenModal,
    }, dispatch )
);
const connect = component => reduxConnect(
    mapStateToProps,
    mapDispatchToProps,
)( component );

export default {
    actions,
    connect,
    reducer,
};



// WEBPACK FOOTER //
// ./src/reducers/modal.js